<template>
    <div>
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl dc">视频管理</span>
        </div>
        <div class="nav cb">
            <div :class="`li li-1${(!query.type || query.type === 'publish') ? ' active' : ''}`" @click="tabSwitch('publish')">已发布({{count.publish}})</div>
            <div :class="`li li-2${query.type === 'checking' ? ' active' : ''}`" @click="tabSwitch('checking')">发布中({{count.checking}})</div>
            <div :class="`li li-3${query.type === 'failed' ? ' active' : ''}`" @click="tabSwitch('failed')">未通过({{count.failed}})</div>
            <div :class="`li li-4${query.type === 'draft' ? ' active' : ''}`" @click="tabSwitch('draft')">草稿箱({{count.draft}})</div>
            <div :class="`bot-line${lineClass}`"></div>
        </div>
        <div v-show="!query.type || query.type === 'publish'">
            <div v-show="!is_loading && !publishVideos.length" class="empty-box">
                暂无已发布的视频("▔□▔)
                <i class="icon-empty"></i>
                <router-link to="/users/upload" class="upload-btn bg">
                    立即投稿
                    <i class="icon-arrow-r"></i>
                </router-link>
            </div>
            <div>
                <div class="video-list cb" v-for="v in publishVideos" :key="v.id">
                    <a :href="`/videos/${v.id}`" class="cover-box" target="_blank">
                        <i class="icon-play"></i>
                        <img class="cover" v-lazy="v.thumb">
                        <div class="mask"></div>
                        <span v-show="v.duration" class="time">{{duration(v.duration)}}</span>
                    </a>
                    <div class="content">
                        <div class="title-box">
                            <a :href="`/video/${v.id}`" class="title" target="_blank">{{v.title}}</a>
                            <span class="add-time">{{v.addtime}}</span>
                        </div>
                        <div class="toolbar-box">
                            <div>
                            <span class="toolbar">
                                <i class="icon-played"></i>
                                {{v.view}}
                            </span>
                                <span class="toolbar">
                                <i class="icon-commented"></i>
                                {{v.comment}}
                            </span>
                                <span class="toolbar">
                                <i class="icon-liked"></i>
                                {{v.like}}
                            </span>
                                <span class="toolbar">
                                <i class="icon-share"></i>
                                {{v.share}}
                            </span>
                            </div>
                            <div class="manage-box">
                                <router-link :to="`/users/videos/${v.id}/edit`" class="manage bg">
                                    <i class="icon-edit"></i>
                                    编辑
                                </router-link>
                                <span @click="del(v.id)" class="manage btn-del">
                                <i v-show="!is_deleting[v.id]" class="icon-bin"></i>
                                <i v-show="is_deleting[v.id]" class="loading"></i>
                                删除
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination
                    v-if="!is_loading && count.publish > 20"
                    background layout="total, prev, pager, next"
                    @current-change="nextPage"
                    :page-size="20"
                    :total="count.publish"
                    class="page">
            </el-pagination>
        </div>

        <div v-show="query.type === 'checking'">
            <div v-show="!is_loading && !checkingVideos.length" class="empty-box">
                暂无正在审核的作品("▔□▔)
                <i class="icon-empty"></i>
            </div>
            <div>
                <div class="video-list cb" v-for="v in checkingVideos" :key="v.id">
                    <router-link :to="`/users/videos/${v.id}/edit`" class="cover-box">
                        <i class="icon-edit"></i>
                        <img class="cover" v-lazy="v.thumb">
                        <div class="mask"></div>
                        <span v-show="v.duration" class="time">{{duration(v.duration)}}</span>
                    </router-link>
                    <div class="content">
                        <div class="title-box">
                            <router-link :to="`/users/videos/${v.id}/edit`" class="title">{{v.title}}</router-link>
                            <span class="add-time">{{v.addtime}}</span>
                        </div>
                        <div class="toolbar-box">
                            <div>
                            <span class="toolbar">
                                <i class="icon-checking"></i>
                                正在审核中
                            </span>
                            </div>
                            <div class="manage-box">
                                <router-link :to="`/users/videos/${v.id}/edit`" class="manage bg">
                                    <i class="icon-edit"></i>
                                    编辑
                                </router-link>
                                <span @click="del(v.id)" class="manage btn-del">
                                <i v-show="!is_deleting[v.id]" class="icon-bin"></i>
                                <i v-show="is_deleting[v.id]" class="loading"></i>
                                删除
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination
                    v-if="!is_loading && count.checking > 20"
                    background layout="total, prev, pager, next"
                    @current-change="nextPage"
                    :page-size="20"
                    :total="count.checking"
                    class="page">
            </el-pagination>
        </div>

        <div v-show="query.type === 'failed'">
            <div v-show="!is_loading && !failedVideos.length" class="empty-box">
                暂无未通过的作品("▔□▔)
                <i class="icon-empty"></i>
            </div>
            <div>
                <div class="video-list cb" v-for="v in failedVideos" :key="v.id">
                    <router-link :to="`/users/videos/${v.id}/edit`" class="cover-box">
                        <i class="icon-edit"></i>
                        <img class="cover" v-lazy="v.thumb">
                        <div class="mask"></div>
                        <span v-show="v.duration" class="time">{{duration(v.duration)}}</span>
                    </router-link>
                    <div class="content">
                        <div class="title-box">
                            <router-link :to="`/users/videos/${v.id}/edit`" class="title">{{v.title}}</router-link>
                            <span class="add-time">{{v.addtime}}</span>
                        </div>
                        <div class="toolbar-box">
                            <div>
                            <span class="toolbar">
                                <i class="icon-success"></i>
                                <!--视频包含色情内容-->
                                未通过审核, 原因: 不符合投稿规范
                            </span>
                            </div>
                            <div class="manage-box">
                                <router-link :to="`/users/videos/${v.id}/edit`" class="manage bg">
                                    <i class="icon-edit"></i>
                                    编辑
                                </router-link>
                                <span @click="del(v.id)" class="manage btn-del">
                                <i v-show="!is_deleting[v.id]" class="icon-bin"></i>
                                <i v-show="is_deleting[v.id]" class="loading"></i>
                                删除
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination
                    v-show="!is_loading && count.failed > 20"
                    background layout="total, prev, pager, next"
                    @current-change="nextPage"
                    :page-size="20"
                    :total="count.failed"
                    class="page">
            </el-pagination>
        </div>


        <div v-show="query.type === 'draft'">
            <div v-show="!is_loading && !draftVideos.length" class="empty-box">
                暂无保存为草稿的作品("▔□▔)
                <i class="icon-empty"></i>
            </div>
            <div>
                <div class="video-list cb" v-for="v in draftVideos" :key="v.id">
                    <router-link :to="`/users/videos/${v.id}/edit`" class="cover-box">
                        <i class="icon-edit"></i>
                        <img class="cover" v-lazy="v.thumb">
                        <div class="mask"></div>
                        <span v-show="v.duration" class="time">{{duration(v.duration)}}</span>
                    </router-link>
                    <div class="content">
                        <div class="title-box">
                            <router-link :to="`/users/videos/${v.id}/edit`" class="title">{{v.title}}</router-link>
                            <span class="add-time">{{v.addtime}}</span>
                        </div>
                        <div class="toolbar-box">
                            <div>
                            <span class="toolbar">
                                <i class="icon-success"></i>
                                已保存为草稿
                            </span>
                            </div>
                            <div class="manage-box">
                                <router-link :to="`/users/videos/${v.id}/edit`" class="manage bg">
                                    <i class="icon-edit"></i>
                                    编辑
                                </router-link>
                                <span @click="del(v.id)" class="manage btn-del">
                                <i v-show="!is_deleting[v.id]" class="icon-bin"></i>
                                <i v-show="is_deleting[v.id]" class="loading"></i>
                                删除
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination
                    v-if="!is_loading && count.draft > 20"
                    background layout="total, prev, pager, next"
                    @current-change="nextPage"
                    :page-size="20"
                    :total="count.publish"
                    class="page">
            </el-pagination>
        </div>




    </div>
</template>

<script>
    export default {
        data: () => ({
            videos: [],
            count: {
                publish: 0,
                checking: 0,
                failed: 0,
                draft: 0,
            },
            publishVideos: [],
            checkingVideos: [],
            failedVideos: [],
            draftVideos: [],
            is_deleting: {},
            is_loading: true,
        }),
        methods: {
            duration(t) {
                let m = ~~(t / 1000 / 60), s = ~~(t / 1000 % 60);
                return `00 : ${m < 10 ? '0' + m : m} : ${s < 10 ? '0' + s : s}`;
            },
            tabSwitch(type) {
                this.$router.push(`manage?type=${type}`);
            },
            del(id) {
                this.confirm({
                    title: '删除视频',
                    content: '确定要删除这条作品吗？删除后将无法进行恢复',
                    sure: '确定',
                    cancel: '取消',
                    sureCb: () => {
                        if (this.is_deleting[id]) return;
                        this.$set(this.is_deleting, id, true);
                        this.api.del(`users/videos/${id}`).then(() => {
                            this.alert.suc('成功删除作品!');
                            --this.count[this.query.type];
                            this.reload(this);
                        }, () => {
                            this.alert.err('删除失败, 请重新尝试!');
                            this.$set(this.is_deleting, id, false);
                        })
                    },
                })
            },
            async reload(to) {
                this.is_loading = true;
                let {type, page} = to.query;

                let status;
                switch(type) {
                    case 'failed': status = 0;break;
                    case 'draft': status = 2;break;
                    case 'checking': status = 4;break;
                    default: type = 'publish';status = 1;
                }
                this[type + 'Videos'] = await this.api.get('users/videos', {status, page}).catch(this.err);
                this.is_loading = false;
            },
            nextPage(page) {
                this.$router.push(`manage?type=${this.type}&page=${page}`);
            }
        },
        computed: {
            query() {
                return this.$route.query;
            },
            type() {
                return this.query.type;
            },
            lineClass() {
                let {type} = this, className;
                if (!type || type === 'publish') {
                    className = '';
                } else if (type === 'checking') {
                    className = ' li-2-active';
                } else if (type === 'failed') {
                    className = ' li-3-active';
                } else {
                    className = ' li-4-active';
                }
                return className;
            },
            page() {
                return +this.$route.query.page || 1;
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.reload(to);
            next();
        },
        async beforeMount() {
            this.is_loading = true;
            const {api} = this;
            api.get('users/videos/count').then(e => {
                let {count} = this;
                count.publish = e.publish;
                count.checking = e.checking;
                count.failed = e.failed;
                count.draft = e.draft;
            }).catch(this.err);

            let {query} = this.$route, {type, page} = query;

            let status;
            switch(type) {
                case 'failed': status = 0;break;
                case 'draft': status = 2;break;
                case 'checking': status = 4;break;
                default: type = 'publish';status = 1;
            }
            this[type + 'Videos'] = await api.get('users/videos', {status, page}).catch(this.err);
            this.is_loading = false;
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/video-manage.css";
</style>


// WEBPACK FOOTER //
// src/views/user/VideoManage.vue